import { render, staticRenderFns } from "./FormsDataDiscrepancies.vue?vue&type=template&id=8dfc0be4"
import script from "./FormsDataDiscrepancies.vue?vue&type=script&lang=js"
export * from "./FormsDataDiscrepancies.vue?vue&type=script&lang=js"
import style0 from "./FormsDataDiscrepancies.vue?vue&type=style&index=0&id=8dfc0be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports